<template>
  <div class="part1" id="if2021-forum-desc">
    <img
      src="https://summit-img.geekpark.net/if2021/pc/001-1-pc.png"
      class="img1"
    />
    <img
      src="https://summit-img.geekpark.net/if2021/pc/001-2-pc.png"
      class="img2"
    />
    <img
      src="https://summit-img.geekpark.net/if2021/pc/01-背景-creation.svg"
      class="img3 move-img"
      :style="{ transform: `translate3d(${moveOnImgPosition1}px,0,0)` }"
    />
    <img
      src="https://summit-img.geekpark.net/if2021/pc/01-背景-INSPIRATION.svg"
      class="img4 move-img"
      :style="{ transform: `translate3d(${moveOnImgPosition1}px,0,0)` }"
    />
    <img
      src="https://summit-img.geekpark.net/if2021/pc/01-1-TECHNOLOGYCREATION&INSPIRATION.svg"
      class="img5"
    />
    <img
      src="https://summit-img.geekpark.net/if2021/pc/大会logo-通用.svg"
      class="img6 move-img"
      :style="{ transform: `translate3d(${moveOnImgPosition2}px,0,0)` }"
    />
    <img
      src="https://summit-img.geekpark.net/if2021/pc/01-科技创造美好-pc.svg"
      class="img7 move-img"
      :style="{ transform: `translate3d(${moveOnImgPosition2}px,0,0)` }"
    />
    <img
      src="https://summit-img.geekpark.net/if2021/pc/创新大会2021 抖音搜索-通用.svg"
      class="img8 move-img"
      :style="{ transform: `translate3d(${moveOnImgPosition2}px,0,0)` }"
    />
    <img
      src="https://summit-img.geekpark.net/if2021/pc/01-联合主办方-合作平台-pc.svg"
      class="img9"
    />
    <img
      src="https://summit-img.geekpark.net/if2021/pc/01-时间-pc.svg"
      class="img10 move-img"
      :style="{ transform: `translate3d(${moveOnImgPosition2}px,0,0)` }"
    />
    <img
      src="https://summit-img.geekpark.net/if2021/pc/01-背景-tech.svg"
      class="img11"
    />
  </div>
</template>

<script>
export default {
  name: "Part1",
  data() {
    return { moveOnImgPosition1: 0, moveOnImgPosition2: 0 };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll, false);
  },
  mounted() {},
  methods: {
    handleScroll() {
      const scrollHeight =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const scrollInstance = scrollHeight - this.scrollHeight;
      this.scrollHeight = scrollHeight;
      const { left, width } = document
        .querySelector(".img6")
        .getBoundingClientRect();
      if (left <= document.body.offsetWidth && left >= -width) {
        if (
          (scrollInstance > 0 && this.moveOnImgPosition1 >= -width) ||
          (scrollInstance < 0 && this.moveOnImgPosition1 <= 0)
        ) {
          this.moveOnImgPosition1 -= scrollInstance / 1;
          this.moveOnImgPosition2 -= scrollInstance / 4;
        }
      }
      if (this.scrollHeight === 0) {
        this.moveOnImgPosition1 = 0;
        this.moveOnImgPosition2 = 0;
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll, false);
  },
};
</script>

<style lang="less" scoped>
.part1 {
  padding: 5vh 0vh 5vh 0vh;
  height: 100vh;
  white-space: nowrap;
  position: relative;
  .move-img {
    transition: transform 0.5s ease-out, -webkit-transform 0.5s ease-out;
  }
  .img1,
  .img2 {
    height: 100%;
    width: auto;
  }
  .img2 {
    margin-left: -95vh;
  }
  .img3 {
    position: absolute;
    bottom: -10vh;
    left: 0vh;
    z-index: -2;
    width: 112vh;
    height: auto;
  }
  .img4 {
    position: absolute;
    top: -2vh;
    left: 133vh;
    z-index: -2;
    width: 112vh;
    height: auto;
  }
  .img5 {
    height: 6vh;
    width: auto;
    position: absolute;
    bottom: 10vh;
    left: 11vh;
  }
  .img6 {
    height: 67vh;
    width: auto;
    position: absolute;
    bottom: 17vh;
    left: 30vh;
  }
  .img7 {
    height: 12vh;
    width: auto;
    position: absolute;
    bottom: 58vh;
    left: 132vh;
  }
  .img8 {
    height: 12vh;
    width: auto;
    position: absolute;
    bottom: 34vh;
    left: 132vh;
  }
  .img9 {
    height: 3vh;
    width: auto;
    position: absolute;
    bottom: 24vh;
    left: 132vh;
  }
  .img10 {
    height: 10vh;
    width: auto;
    position: absolute;
    bottom: 9vh;
    left: 188vh;
  }
  .img11 {
    height: 66vh;
    width: auto;
    position: absolute;
    bottom: 28vh;
    right: -8vh;
    z-index: -2;
  }
}
</style>